export const stageStats = [
{ stage: 'Pokémon Stadium 2',
  shortName: 'PS2',
  gamesPlayed: 428,
  setsPlayed: 360,
  gamesBanned: 29,
  setsBanned: 27,
  starter: true },
{ stage: 'Smashville',
  shortName: 'SV',
  gamesPlayed: 124,
  setsPlayed: 114,
  gamesBanned: 92,
  setsBanned: 90,
  starter: true },
{ stage: 'Battlefield',
  shortName: 'BF',
  gamesPlayed: 161,
  setsPlayed: 149,
  gamesBanned: 117,
  setsBanned: 116,
  starter: true },
{ stage: 'Final Destination',
  shortName: 'FD',
  gamesPlayed: 79,
  setsPlayed: 75,
  gamesBanned: 201,
  setsBanned: 187,
  starter: true },
{ stage: 'Lylat Cruise',
  shortName: 'Lylat',
  gamesPlayed: 37,
  setsPlayed: 37,
  gamesBanned: 172,
  setsBanned: 170,
  starter: false },
{ stage: 'Town And City',
  shortName: 'T&C',
  gamesPlayed: 139,
  setsPlayed: 135,
  gamesBanned: 44,
  setsBanned: 44,
  starter: true },
{ stage: "Yoshi's Island (Brawl)",
  shortName: 'Y.Island',
  gamesPlayed: 20,
  setsPlayed: 20,
  gamesBanned: 218,
  setsBanned: 210,
  starter: false },
{ stage: 'Kalos Pokémon League',
  shortName: 'Kalos',
  gamesPlayed: 64,
  setsPlayed: 62,
  gamesBanned: 140,
  setsBanned: 140,
  starter: false },
{ stage: "Yoshi's Story",
  shortName: 'Y.Story',
  gamesPlayed: 31,
  setsPlayed: 31,
  gamesBanned: 141,
  setsBanned: 135,
  starter: false },

];

export const banPairs = [
{ stageA: 'Pokémon Stadium 2',
  'Pokémon Stadium 2': 0,
  Smashville: 3,
  Battlefield: 5,
  'Final Destination': 7,
  'Lylat Cruise': 2,
  'Town And City': 5,
  "Yoshi's Island (Brawl)": 4,
  'Kalos Pokémon League': 1,
  "Yoshi's Story": 2 },
{ stageA: 'Smashville',
  'Pokémon Stadium 2': 3,
  Smashville: 0,
  Battlefield: 5,
  'Final Destination': 22,
  'Lylat Cruise': 10,
  'Town And City': 6,
  "Yoshi's Island (Brawl)": 31,
  'Kalos Pokémon League': 6,
  "Yoshi's Story": 9 },
{ stageA: 'Battlefield',
  'Pokémon Stadium 2': 5,
  Smashville: 5,
  Battlefield: 0,
  'Final Destination': 11,
  'Lylat Cruise': 19,
  'Town And City': 4,
  "Yoshi's Island (Brawl)": 18,
  'Kalos Pokémon League': 3,
  "Yoshi's Story": 52 },
{ stageA: 'Final Destination',
  'Pokémon Stadium 2': 7,
  Smashville: 22,
  Battlefield: 11,
  'Final Destination': 0,
  'Lylat Cruise': 26,
  'Town And City': 13,
  "Yoshi's Island (Brawl)": 39,
  'Kalos Pokémon League': 74,
  "Yoshi's Story": 9 },
{ stageA: 'Lylat Cruise',
  'Pokémon Stadium 2': 2,
  Smashville: 10,
  Battlefield: 19,
  'Final Destination': 26,
  'Lylat Cruise': 0,
  'Town And City': 6,
  "Yoshi's Island (Brawl)": 64,
  'Kalos Pokémon League': 20,
  "Yoshi's Story": 25 },
{ stageA: 'Town And City',
  'Pokémon Stadium 2': 5,
  Smashville: 6,
  Battlefield: 4,
  'Final Destination': 13,
  'Lylat Cruise': 6,
  'Town And City': 0,
  "Yoshi's Island (Brawl)": 3,
  'Kalos Pokémon League': 7,
  "Yoshi's Story": 0 },
{ stageA: "Yoshi's Island (Brawl)",
  'Pokémon Stadium 2': 4,
  Smashville: 31,
  Battlefield: 18,
  'Final Destination': 39,
  'Lylat Cruise': 64,
  'Town And City': 3,
  "Yoshi's Island (Brawl)": 0,
  'Kalos Pokémon League': 22,
  "Yoshi's Story": 37 },
{ stageA: 'Kalos Pokémon League',
  'Pokémon Stadium 2': 1,
  Smashville: 6,
  Battlefield: 3,
  'Final Destination': 74,
  'Lylat Cruise': 20,
  'Town And City': 7,
  "Yoshi's Island (Brawl)": 22,
  'Kalos Pokémon League': 0,
  "Yoshi's Story": 7 },
{ stageA: "Yoshi's Story",
  'Pokémon Stadium 2': 2,
  Smashville: 9,
  Battlefield: 52,
  'Final Destination': 9,
  'Lylat Cruise': 25,
  'Town And City': 0,
  "Yoshi's Island (Brawl)": 37,
  'Kalos Pokémon League': 7,
  "Yoshi's Story": 0 },

];

export const globalStats = 
{ totalGames: 1083,
  totalSets: 535,
  totalBans: 1154,
  setsWithBanRecorded: 466,
  totalBanPairs: 577 };

export const stages = 
[ 'Pokémon Stadium 2',
  'Smashville',
  'Battlefield',
  'Final Destination',
  'Lylat Cruise',
  'Town And City',
  "Yoshi's Island (Brawl)",
  'Kalos Pokémon League',
  "Yoshi's Story" ];

export const shortNames = 
[ 'PS2',
  'SV',
  'BF',
  'FD',
  'Lylat',
  'T&C',
  'Y.Island',
  'Kalos',
  'Y.Story' ];